export enum CssPropertiesNames {
  BackgroundPositionY = 'background-position-y',
  BorderBottomWidth = 'border-bottom-width',
  BorderTopWidth = 'border-top-width',
}
